((document) => {
  const heroBannerContainer = document.querySelector('.vd-hero-banner');
  const heroBanner = document.getElementById('vdHeroBanner');
  const slides = heroBanner.querySelectorAll('.vd-hero-slide');
  const navContainer = document.createElement('div');
  let current = 0;
  let heroCycle = null;

  function beginCycle() {
    heroCycle = setInterval(() => {
      slides[current].classList.remove('is-active');
      document.querySelectorAll('.vd-hero-nav-button').forEach((btn) => {
        btn.classList.remove('active');
      });
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
      document.querySelector(`.vd-hero-nav-button.slide-${current}`).classList.add('active');
    }, 7000);
  }

  function initializeHeroBanner() {
    navContainer.classList.add('vd-hero-nav');

    // -- Don't run if there's no slider or less than 2 slides --
    if (!heroBanner) return;
    if (slides.length < 2) return;

    slides.forEach((slide, index) => {
      const navButton = document.createElement('a');
      navButton.classList.add('vd-hero-nav-button');
      if (index === 0) navButton.classList.add('active');
      navButton.classList.add(`slide-${index}`);
      // navButton.setAttribute("data-slide", index);
      navContainer.appendChild(navButton);
      navButton.addEventListener('click', () => {
        clearInterval(heroCycle);
        slides.forEach((s) => s.classList.remove('is-active'));
        slides[index].classList.add('is-active');
        current = index;
        document.querySelectorAll('.vd-hero-nav-button').forEach((btn) => {
          btn.classList.remove('active');
        });
        document.querySelector(`.vd-hero-nav-button.slide-${current}`).classList.add('active');
        beginCycle();
      });
    });
    heroBannerContainer.appendChild(navContainer);
    beginCycle();
  }

  window.vm.onload(() => {
    initializeHeroBanner();
  });
})(document);
